// Global Types
import type {
  $WithRouter,
} from '@vroskus/library-navigation';

// Global Types
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  scrollTop,
} from '@vroskus/library-helpers/dist/browser';
import {
  getErrorLevel,
} from '../../../helpers';

// Components
import Page from '../../layout/Page';
import Loader from '../../layout/Loader';
import ContentSection from '../../sections/CustomPageSections/ContentSection';
import NotFoundSection from '../../sections/CommonSections/NotFoundSection';

// Services
import Services from '../../../services';

// Types
import type {
  $ReducerState,
} from '../../../redux';
import type {
  $RedirectAction,
  $SetRegionAction,
} from '../../../redux/modules/main/actions';
import type {
  $Tags,
} from '../../../types';

type $OptionalProps = $WithRouter;

export type $OwnProps = $OptionalProps;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  redirect: $RedirectAction;
  setRegion: $SetRegionAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  initialised: boolean;
  item: $Model<'CustomPage'> | null;
};

const pageDataNotFoundErrorMessage = 'Page data not found';

class CustomPageView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      initialised: false,
      item: null,
    };
  }

  componentDidMount(): void {
    this.init();
  }

  getTags(): $Tags {
    const {
      item,
    } = this.state;

    const tags: $Tags = {
      image: undefined,
      title: 'CustomPage',
      url: undefined,
    };

    if (item) {
      tags.title = item.Name;
    }

    return tags;
  }

  async init(): Promise<void> {
    const {
      main,
      params,
      redirect,
      setRegion,
    } = this.props;
    const {
      RegionId,
    } = main;
    const {
      param1,
    } = params;

    try {
      scrollTop();

      if (param1) {
        const item = await Services.Api.getCustomPagePageData({
          param1,
        });

        if (item !== null) {
          if (RegionId === null) {
            await setRegion({
              RegionId: item.RegionId,
            });
          }

          this.setState({
            initialised: true,
            item,
          });
        } else {
          throw new Error(pageDataNotFoundErrorMessage);
        }
      } else {
        redirect({
          pathname: '/',
        });
      }
    } catch (error) {
      ErrorLog.exception(
        error as Error,
        getErrorLevel(
          error as Error,
          pageDataNotFoundErrorMessage,
        ),
      );

      redirect({
        pathname: '/',
      });
    }
  }

  render() {
    const {
      initialised,
      item,
    } = this.state;

    return (
      <Page
        id={webPages.customPage}
        tags={this.getTags()}
      >
        <Loader loading={!initialised}>
          {(item !== null ? (
            <ContentSection item={item} />
          ) : (
            <NotFoundSection id={webSections[webPages.customPage].notFound} />
          ))}
        </Loader>
      </Page>
    );
  }
}

export default CustomPageView;
